import {CommonModule} from '@angular/common';
import {TitleComponent} from './title.component';
import {MaterialModule} from '../../../shared/material.module';
import {NgModule} from '@angular/core';

@NgModule({
  declarations: [TitleComponent],
  exports: [TitleComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})

export class TitleModule {
}
